
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/user/[tabKey]",
      function () {
        return require("private-next-pages/accounts/user/[tabKey].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/user/[tabKey]"])
      });
    }
  